import { connect } from 'react-redux';
import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

import type {
  OnVisiblePayload,
  ThumbnailsDispatchProps,
  ThumbnailsStateProps,
} from 'src/components/molecules/Thumbnails/Thumbnails';
import { Thumbnails } from 'src/components/molecules/Thumbnails/Thumbnails';
import type {
  NextOrPreviousPayload,
  SetCurrentMediaPayload,
} from 'src/components/organisms/ProductMediaCarousel/types';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProductMedia } from 'src/redux/product/selectors';
import { actions } from 'src/redux/productMediaCarousel/slice';
import type { AppThunkDispatch } from 'src/redux/store';

const mapStateToProps = (state: ReduxApplicationState): ThumbnailsStateProps => {
  return {
    media: selectProductMedia(state),
    currentMedia: state.productMediaCarousel.currentMedia,
  };
};

const mapDispatchToProps = (dispatch: AppThunkDispatch): ThumbnailsDispatchProps => {
  return {
    onVisible: ({ totalMedia }: OnVisiblePayload) => {
      deferTracking(() =>
        sendGAEvent({
          event: 'custom_event',
          event_category: 'Media carousel',
          event_action: 'Impression',
          event_label: String(totalMedia),
        }),
      );
    },
    onNextMedia: (payload: NextOrPreviousPayload) => {
      dispatch(actions.nextMedia(payload));
    },
    onPrevMedia: (payload: NextOrPreviousPayload) => {
      dispatch(actions.prevMedia(payload));
    },
    setCurrentMedia: (payload: SetCurrentMediaPayload) =>
      dispatch(actions.setCurrentMedia(payload)),
  };
};

export const ThumbnailsContainer = connect(mapStateToProps, mapDispatchToProps)(Thumbnails);
